<div class="modal-dialog" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
	<div class="goreact-modal-header">
		<h2 class="modal-title" [id]="dialogTitleId">{{modalTitleValue()}}</h2>
		<button
			class="close-btn"
			type="button"
			[attr.aria-label]="('common_close' | translate)"
			(click)="cancel()">
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div class="goreact-modal-body">
		<ngx-library-collection-viewer
			data-cy="library-modal-body"
			[filterType]="data.filterType"
			[mode]="data.mode"
			[previewable]="data.previewable"
			[create]="data.create"
			[openToOrg]="data.openToOrg"
			[context]="data.context"
			[collectionManagement]="collectionManagement"
			(selectItem)="selectItem($event.item)"
			(cancel)="cancel()">
		</ngx-library-collection-viewer>
	</div>
</div>
